import _Date$now from "@babel/runtime-corejs3/core-js-stable/date/now";
import "core-js/modules/es.function.name.js";
import { useCallback, useLayoutEffect, useMemo, useRef } from 'react';
import debounceFn from './debounce';
var EventSpy = function EventSpy(_ref) {
  var debounce = _ref.debounce,
    name = _ref.name,
    onEvent = _ref.onEvent,
    target = _ref.target;
  // We need to save the "onEvent" to ref.
  // This is because "onEvent" may change from time to time, but debounce may still fire to the older callback.
  var onEventRef = useRef();
  onEventRef.current = onEvent;
  var debouncer = useMemo(function () {
    return debounceFn(function (event) {
      var current = onEventRef.current;
      current && current(event);
    }, debounce);
  }, [debounce, onEventRef]);
  var handleEvent = useCallback(function (event) {
    event.timeStampLow = _Date$now();
    debouncer(event);
  }, [debouncer]);
  useLayoutEffect(function () {
    target.addEventListener(name, handleEvent, {
      passive: true
    });
    handleEvent({
      target: target,
      type: name
    });
    return function () {
      return target.removeEventListener(name, handleEvent);
    };
  }, [name, handleEvent, target]);
  return false;
};
EventSpy.defaultProps = {
  debounce: 200
};
export default EventSpy;